import { useState } from "react";
import { useAppContext } from "../context/AppContext";
import { resolveMerchantLogoUrl } from "../utils/merchantLogo.utils";
import css from "./PageHeader.module.css";

export default function PageHeader() {
  const { participantId, options } = useAppContext();
  const [logoUrl, setLogoUrl] = useState(() =>
    typeof options.logo === "string"
      ? resolveMerchantLogoUrl(participantId, options.logo)
      : undefined,
  );

  return (
    <header>
      {logoUrl && (
        <img
          src={logoUrl}
          alt="Merchant logo"
          className={css.logo}
          onError={() => setLogoUrl(undefined)}
        />
      )}
    </header>
  );
}
